import { Stack, styled } from '@mui/material';

export const ResponsiveStackContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));
